<template>
  <router-view />
  <!-- 回到顶部 -->
  <el-backtop :bottom="100">
    <el-icon><ArrowUpBold /></el-icon>
  </el-backtop>
</template>

<script setup>
import { ArrowUpBold } from "@element-plus/icons-vue";
</script>

<style lang="scss">
#app {
  width: 100%;
  height: 100%;
  // 回到顶部
  .el-backtop {
    .el-icon {
      color: #000;
    }
  }
}
</style>
